module.exports = __webpack_public_path__ + "static/media/20240130084134_IMG_5081 (1).6f89ee68.jpg";